import { defineEvent } from '../types/event';
export var CART_SYNC = defineEvent({
    platforms: [
        {
            name: 'GTM',
            alias: 'cart_sync'
        }
    ]
});
